<router-outlet></router-outlet>
<!-- <app-home ></app-home> -->
<!-- <app-charts></app-charts> -->